import { LoginActionConst } from "../Constants/AuthConstants";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";

/**
 * User Login Action
 * @param {Object} fields - Login credentials
 * @param {string} fields.email - User email
 * @param {string} fields.password - User password
 */
export const UserLogInAction = (fields) => {
  return async (dispatch) => {
    dispatch({
      type: LoginActionConst.USER_LOGIN_REQUEST,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      email: fields.email,
      password: fields.password,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(`${BASE_URL}${API_ENDPOINTS.LOGIN}`, requestOptions);
      const result = await response.json();
      
      // Check if the response is successful based on statusCode
      if (result.statusCode === 200) {
        // Save login success to localStorage
        localStorage.setItem("loginSuccess", JSON.stringify(result));
        
        // Save the access token separately for easy access
        if (result.data && result.data.accessToken) {
          localStorage.setItem("accessToken", result.data.accessToken);
        }

        dispatch({
          type: LoginActionConst.USER_LOGIN_SUCC,
          result: result,
        });
        
        return result;
      } else {
        dispatch({
          type: LoginActionConst.USER_LOGIN_FAIL,
          result: result,
        });
        return result;
      }
    } catch (error) {
      console.error("Login error:", error);
      const errorResult = {
        statusCode: 500,
        data: null,
        message: error.message || "Network error occurred",
        timestamp: new Date().toISOString(),
      };
      dispatch({
        type: LoginActionConst.USER_LOGIN_FAIL,
        result: errorResult,
      });
      return errorResult;
    }
  };
};

/**
 * User Logout Action
 */
export const UserLogoutAction = () => {
  return (dispatch) => {
    // Clear localStorage
    localStorage.removeItem("loginSuccess");
    localStorage.removeItem("accessToken");
    
    // Clear sessionStorage if any auth data exists there
    sessionStorage.removeItem("loginSuccess");
    sessionStorage.removeItem("accessToken");

    dispatch({
      type: LoginActionConst.USER_LOGOUT,
    });
  };
};

